<template>
  <b-modal
    id="modal-download-dokumen"
    centered
    hide-footer
    header-class="border-bottom-0 pb-0"
  >
    <!-- Custom Header -->
    <template #modal-header="{ close }">
      <div class="d-flex align-items-center justify-content-between w-100 pb-2 border-bottom">
        <div class="d-flex align-items-center">
          <div 
            class="bg-light text-primary rounded-lg d-flex align-items-center justify-content-center mr-3"
            style="width: 40px; height: 40px;"
          >
            <i class="fa fa-folder-open fa-lg"></i>
          </div>
          <div>
            <h6 class="font-weight-bold text-dark mb-0">Dokumen Permohonan</h6>
            <small class="text-muted">Pilih file yang ingin Anda unduh</small>
          </div>
        </div>
        <b-button variant="light" size="sm" class="rounded-circle  border-0" @click="close()">
          <i class="fa fa-times text-muted"></i>
        </b-button>
      </div>
    </template>

    <!-- Content / List Group Dokumen -->
    <div class="py-2 w-100">
      <!-- Menggunakan b-list-group -->
      <b-list-group v-if="availableFiles.length > 0" class="w-100">
        <b-list-group-item 
          v-for="(file, index) in availableFiles" 
          :key="index"
          class="d-flex align-items-center justify-content-between p-3 border-left-0 border-right-0 border-top-0 border-bottom"
        >
          <!-- Informasi Dokumen -->
          <div class="d-flex align-items-center pr-2" style="flex: 1; min-width: 0;">
            <div 
              class="bg-light rounded d-flex align-items-center justify-content-center mr-3 flex-shrink-0"
              style="width: 38px; height: 38px;"
            >
              <i :class="file.icon"></i>
            </div>
            <div class="text-truncate">
              <h6 class="font-weight-bold text-dark mb-0 small text-truncate">{{ file.label }}</h6>
              <small class="text-muted d-block text-truncate" style="font-size: 11px;">Format file: Berkas Lampiran</small>
            </div>
          </div>

          <!-- Tombol Unduh -->
          <b-button
            :href="file.url"
            target="_blank"
            variant="primary"
            size="sm"
            class="rounded-pill font-weight-bold px-3 d-inline-flex align-items-center flex-shrink-0 ml-2"
          >
            <i class="fa fa-download mr-1"></i> Unduh
          </b-button>
        </b-list-group-item>
      </b-list-group>

      <!-- Empty State jika tidak ada file -->
      <div v-else class="text-center py-4 text-muted w-100">
        <i class="fa fa-folder-open fa-3x mb-2 text-secondary opacity-50"></i>
        <p class="mb-0 small">Tidak ada dokumen yang dapat diunduh untuk permohonan ini.</p>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalDownloadDokumen',
  props: {
    selectedData: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    availableFiles() {
      if (!this.selectedData) return [];
      
      const data = this.selectedData;
      const files = [];

      // 1. Tagihan (Prioritas III -> II -> I)
      const tagihanUrl = data.file_tagihan_iii || (data.file_tagihan_ii && data.file_tagihan_i ? data.file_tagihan_ii : data.file_tagihan_i);
      if (tagihanUrl) {
        files.push({
          label: 'File Tagihan',
          url: tagihanUrl,
          icon: 'fa fa-file-pdf-o text-danger'
        });
      }

      // 2. Bukti Pembayaran
      if (data.bukti_pembayaran) {
        files.push({
          label: 'Bukti Penerimaan Negara(SIMPONI)',
          url: data.bukti_pembayaran,
          icon: 'fa fa-file-pdf-o text-success'
        });
      }

      if (data.bukti_pembayaran_pemohon) {
        files.push({
          label: 'Bukti Pembayaran',
          url: data.bukti_pembayaran_pemohon,
          icon: 'fa fa-file-pdf-o text-success'
        });
      }

      // 3. Surat Tugas
      const suratTugasUrl = data.filename_final_surat_tugas || data.filename_konsep_surat_tugas;
      if (suratTugasUrl) {
        files.push({
          label: data.filename_final_surat_tugas ? 'Surat Tugas' : 'Konsep Surat Tugas',
          url: suratTugasUrl,
          icon: 'fa fa-file text-info'
        });
      }

      // 4. Undangan
      const undanganUrl = data.filename_final_undangan || data.filename_konsep_undangan;
      if (undanganUrl) {
        files.push({
          label: data.filename_final_undangan ? 'Undangan' : 'Konsep Undangan',
          url: undanganUrl,
          icon: 'fa fa-envelope-open text-primary'
        });
      }

      // 5. Berita Acara (BA Vertek)
      // if (data.file_ba_vertek) {
      //   files.push({
      //     label: 'Berita Acara (Vertek)',
      //     url: data.file_ba_vertek,
      //     icon: 'fa fa-file text-secondary'
      //   });
      // }

      // 6. Memorandum
      // const memoUrl = data.file_final_memorandum || data.file_konsep_memorandum;
      // if (memoUrl) {
      //   files.push({
      //     label: data.file_final_memorandum ? 'Memorandum (Final)' : 'Konsep Memorandum',
      //     url: memoUrl,
      //     icon: 'fa fa-clipboard text-dark'
      //   });
      // }

      // 7. File Persetujuan
      if (data.file_persetujuan) {
        files.push({
          label: 'File Persetujuan',
          url: data.file_persetujuan,
          icon: 'fa fa-file text-success'
        });
      }

      return files;
    }
  }
}
</script>

<style>
/* Style modal content bawaan BootstrapVue */
#modal-download-dokumen___BV_modal_content_ {
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15) !important;
}

/* Hilangkan padding default body agar list-group menempel penuh ke tepi modal */
#modal-download-dokumen___BV_modal_body_ {
  padding: 0.5rem 0 1rem 0 !important;
}

/* Hapus border pada baris terakhir di list group */
#modal-download-dokumen .list-group-item:last-child {
  border-bottom: none !important;
}
</style>